module.exports = __webpack_public_path__ + "img/vertical_7_1_3016.f149daae.png";